import {FormikErrors} from 'formik';
import {BankDetailsEnum} from '../../schema-types/globalTypes';
import {
  validateBankAccount,
  validateSortCode,
} from '../recommendations/RecommendsWithdrawal/WithdrawalValidators';
import {bankAccountValues} from './bankAccountFields';

export const validateBankAccountForm = (
  values: bankAccountValues
): FormikErrors<bankAccountValues> => {
  const errors: FormikErrors<bankAccountValues> = {};

  if (!values.bankDetails) {
    errors.bankDetails = 'Required';
  } else if (values.bankDetails === BankDetailsEnum.NOT_KNOWN) {
    if (!values.accountName) {
      errors.accountName = 'Required';
    }
    return errors;
  }

  if (!values.accountName) {
    errors.accountName = 'Required';
  }
  if (!values.providerId) {
    errors.providerId = 'Required';
  }
  if (!values.contactId) {
    errors.contactId = 'Required';
  }

  if (!values.accountNumber) {
    errors.accountNumber = 'Required';
  } else if (!validateBankAccount(values.accountNumber)) {
    errors.accountNumber = 'Invalid account number: must be 8 digits';
  }

  if (!values.sortCode) {
    errors.sortCode = 'Required';
  } else if (!validateSortCode(values.sortCode)) {
    errors.sortCode = 'Invalid sort code: must be 6 digits';
  }

  return errors;
};
